import React from 'react'
import { Link } from 'react-static'

class FullWidthImage extends React.Component {
  render() {
    const img = require(`../static/img/${this.props.image}`)
    return (
      <React.Fragment>
        <div className="container">
          <div className="layout">
            <div className="section-hero-img parallax" style={{ backgroundImage: `url(${img})` }}></div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

export default FullWidthImage;



// WEBPACK FOOTER //
// /Users/terrymasher/Development/glenbeigh-ltd/src/components/Full-Width-Image.js